export function dateObjectToServerDay(d) {
  // returns YYYY-MM-DD
  // for API calls that need only the day part
  return [d.getFullYear(), ('0' + (d.getMonth() + 1)).slice(-2), ('0' + d.getDate()).slice(-2)].join('-')
}

export function serverDayToDateObject(d) {
  // reverse of the above
  // converts YYYY-MM-DD to the start of day in the current timezone
  if (isNaN(new Date(d + 'T00:00'))) return null
  return new Date(d + 'T00:00')
}

export function plusDays(date, days) {
  const d = new Date(date.getTime())
  d.setDate(date.getDate() + days)
  return d
}

// The Sunday of the week containing date, as a copy.
export function weekStartOf(date) {
  return plusDays(date, -date.getDay())
}

export const MEDIUM_DATE = new Intl.DateTimeFormat('en-US', { dateStyle: 'medium' })

export function formatServerDay(d) {
  const date = d ? serverDayToDateObject(d) : null
  return date ? MEDIUM_DATE.format(date) : ''
}

// A record cached by one endpoint can be overwritten by a sparser one from
// another - RECEIVE_OBJECT replaces rather than merges - so a timestamp a
// component expects may simply be absent. Intl throws "Invalid time value" on
// an unparseable date, which takes the whole page down, so return null and let
// the caller leave the line out.
export function formatTimestamp(
  value,
  options = { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' }
) {
  if (!value) return null
  const date = new Date(value)
  if (isNaN(date)) return null
  return new Intl.DateTimeFormat('en-US', options).format(date)
}
